export const MapUIConstants = {
    GET_MAPUI: 'GET_MAPUI',
    SET_MAPUI: 'SET_MAPUI'
};